import React, {Component} from 'react'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Modal from '../components/Modal';
import {createNote, updateNote} from '../actions/ClientActions';
import NoteWithMentions from './NoteWithMentions.js';

@connect(
    state => ({
        isSaving: state.modal.isSaving
    }),
    dispatch => bindActionCreators({createNote, updateNote}, dispatch)
)
export default class NoteModal extends Component {
    	constructor(props){
		super(props);
		this.state = {
			noteValue: this.props.initialText ? this.props.initialText : "",
			mentionedUsers : []
		}
	}
    handleSave() {
        var noteData = Object.assign(this.state, {clientId: this.props.clientId});
        if(this.props.noteId) {
            this.props.updateNote(this.props.noteId, noteData);
        } else {
            this.props.createNote(noteData);
        }
    }

    componentDidMount(){
        window.addEventListener('cmdEnter', this.handleSave.bind(this), false);
    }

    componentWillUnmount(){
        window.removeEventListener('cmdEnter', this.handleSave.bind(this));
    }

    handleNoteTextChange(value, mentionedUsers){
		this.setState({
			noteValue : value,
			mentionedUsers : mentionedUsers
		});
	}
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.handleSave.bind(this)}>Save</button>);

        return (
            <Modal actionButton={actionButton} className="modal-success"  title={this.props.noteId ? "Update note" : "Create note"}>
                <NoteWithMentions value={this.state.noteValue} noteChanged={this.handleNoteTextChange.bind(this)} />
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/NoteModal.js